import { Env } from '@stencil/core';

const upsellText = 'Subscribe to SportsLine to get picks, props, projections, & fantasy advice from 3 data models & 40 experts';

type EnvKey = 'qa' | 'dev' | 'local' | 'prod';
type ClientKey = 'sportsline' | 'cbssports';

const envs: EnvKey[] = ['qa', 'dev', 'local', 'prod'];

const getEnv = (): EnvKey => {
  const env = (Env.TARGET_ENV || process.env.TARGET_ENV || '').toLowerCase();
  return envs.includes(env as EnvKey) ? (env as EnvKey) : 'prod';
};

const gameHref = {
  sportsline: {
    qa: (league: string, abbr: string) => `https://qa.sportsline.com/${league}/game-forecast/${abbr}/`,
    dev: (league: string, abbr: string) => `https://dev.sportsline.com/${league}/game-forecast/${abbr}/`,
    local: (league: string, abbr: string) => `https://local.sportsline.com:3000/${league}/game-forecast/${abbr}/`,
    prod: (league: string, abbr: string) => `https://www.sportsline.com/${league}/game-forecast/${abbr}/`,
  },
  cbssports: {
    qa: (league: string, abbr: string) => `https://qa.cbssports.com/${league}/gametracker/preview/${abbr}/`,
    dev: (league: string, abbr: string) => `https://dev.cbssports.com/${league}/gametracker/preview/${abbr}/`,
    local: (league: string, abbr: string) => `https://local.cbssports.com/${league}/gametracker/preview/${abbr}/`,
    prod: (league: string, abbr: string) => `https://www.cbssports.com/${league}/gametracker/preview/${abbr}/`,
  },
};

const subscribeLink = {
  sportsline: {
    qa: () => `https://qa.sportsline.com/join/?xurl=${window.location.href}`,
    dev: () => `https://dev.sportsline.com/join/?xurl=${window.location.href}`,
    local: () => `https://local.sportsline.com:3000/join/?xurl=${window.location.href}`,
    prod: () => `https://www.sportsline.com/join/?xurl=${window.location.href}`,
  },
  cbssports: {
    qa: () => `https://secure.qa.cbssports.com/sportsline/payment?xurl=${window.location.href}`,
    dev: () => `https://secure.dev.cbssports.com/sportsline/payment?xurl=${window.location.href}`,
    local: () => `https://local.cbssports.com/sportsline/payment?xurl=${window.location.href}`,
    prod: () => `https://secure.cbssports.com/sportsline/payment?xurl=${window.location.href}`,
  },
};

function getClientConfig(client: ClientKey) {
  const env = getEnv();
  return {
    subscribeLink: subscribeLink[client][env](),
    gameHref: gameHref[client][env],
    upsellText,
  };
}

export const clients = {
  cbssports: getClientConfig('cbssports'),
  sportsline: getClientConfig('sportsline'),
} as const;
